const selectors = {
  input: ".ginput_container input:not([type='hidden'])",
  textarea: ".ginput_container textarea",
  select: ".ginput_container select",
  focus: "focused",
};

function toggleParentClass(element) {
  const parent = element?.closest(".gfield");

  if (!parent) return;

  if (element.value.length) {
    parent.classList.add(selectors.focus);
  }

  element.addEventListener("focus", () =>
    parent.classList.add(selectors.focus)
  );
  element.addEventListener("blur", () => {
    if (element.value.length) return;

    parent.classList.remove(selectors.focus);
  });
}

const initFileInput = (input) => {
  const parent = input?.closest(".gfield");
  const description = parent.querySelector(":scope > .gfield_description");

  let isFileSelected = parent.querySelector(".gfield_fileupload_filename");

  if (isFileSelected) {
    description.innerHTML =
      `<span>${isFileSelected.innerText}</span>` + description.innerHTML;
  }

  input.addEventListener("change", (e) => {
    const fileName = e.target.files[0].name;

    if (isFileSelected) {
      description.innerHTML = description.innerHTML.replace(
        new RegExp("(<span>.+<\\/span>)"),
        `<span>${fileName}</span>`
      );
    } else {
      description.innerHTML =
        `<span>${fileName}</span>` + description.innerHTML;

      isFileSelected = true;
    }
  });
};

const init = () => {
  const inputs = document.querySelectorAll(selectors.input);
  const textareas = document.querySelectorAll(selectors.textarea);
  const selects = document.querySelectorAll(selectors.select);

  [...inputs, ...textareas, ...selects].map((input) =>
    toggleParentClass(input)
  );

  [...inputs].map((input) => input.type === "file" && initFileInput(input));
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    jQuery(document).on("gform_post_render", init);
  },
  { once: true }
);
